customElements.get("stock-notifier") || customElements.define("stock-notifier", class extends HTMLElement {
  form=this.querySelector('form[action*="klaviyo"]');
  error=this.querySelector("[data-error]");
  revision="2024-06-15";
  button=this.form?.querySelector('[type="submit"]');
  constructor() {
    super();
  }
  connectedCallback() {
    if (!this.form || !this.button) return;
    this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
    const t = this.closest("product-form");
    t && t.addEventListener("variant:change", t => this.reset(t?.detail?.variant?.available ?? !1));
  }
  loadStart() {
    this.form.classList.add("opacity-50", "cursor-wait");
  }
  loadEnd() {
    this.form.classList.remove("opacity-50", "cursor-wait");
  }
  reset(t = !1) {
    this.form.reset(), this.error.textContent = "", this.button.disabled = t;
  }
  onSubmitHandler(t) {
    t.preventDefault();
    const e = new FormData(t.target);
    if ("" !== e.get("email")) {
      this.loadStart();
      const t = {
        data: {
          type: "profile",
          attributes: {
            email: e.get("email")
          }
        }
      }, i = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: t,
            channels: [ "EMAIL" ]
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$shopify:::$default:::" + this.closest("product-form")?.querySelector('[name="id"]').value
              }
            }
          }
        }
      };
      if (fetch(this.form.action, {
        headers: {
          "Content-Type": "application/json",
          revision: this.revision
        },
        body: JSON.stringify(i),
        method: this.form.method
      }).then(t => {
        t.ok ? (this.querySelectorAll("[data-before]").forEach(t => t.classList.add("hidden")), 
        this.querySelectorAll("[data-after]").forEach(t => t.classList.remove("hidden")), 
        window.dataLayer = window.dataLayer || [], window.dataLayer.push({
          event: "notify_me_submit",
          product_size: this.querySelector('[name="id"]').dataset.variantTitle,
          newsletter_opt_in: e.get("list") && e.get("list").length > 1
        })) : (console.warn(t), this.error && (this.error.textContent = window.strings.outOfStock.error));
      }).catch(t => {
        console.warn(t), this.error && (this.error.textContent = window.strings.outOfStock.error);
      }).finally(() => this.loadEnd()), e.get("list") && e.get("list").length > 1) {
        const i = {
          data: {
            type: "subscription",
            attributes: {
              custom_source: "back_in_stock",
              profile: t
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: e.get("list")
                }
              }
            }
          }
        };
        fetch(this.form.action.replace("back-in-stock-subscription", "subscription"), {
          headers: {
            "Content-Type": "application/json",
            revision: this.revision
          },
          body: JSON.stringify(i),
          method: this.form.method
        });
      }
    }
  }
});